import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import terms from './terms.json';
import style from './style.scss';
import Items from 'components/SuggestionsTags/Items';

let arrTags = [];

const SuggestionsTags = ({searchTerm}) => {
    const tags = terms[searchTerm];

    useEffect(() => {
        tags && tags.map((item) => {
            arrTags.push({
                label: item,
                url: `/busqueda?ft=${item}`,
            });
        });

        return function cleanup () {
            arrTags = [];
        }
    }, [searchTerm])

    
    return (
        <div className="tags-content">
            {!!arrTags.length && <Items arrTags={arrTags} searchTerm={searchTerm}/>}
        </div>
    )
}

SuggestionsTags.propTypes = {
    searchTerm: PropTypes.string
}

export default SuggestionsTags;